module.exports = "textarea {\n  height: 136px;\n  overflow-y: hidden;\n  resize: none; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/admin/configs/admin-configs.component.scss
// module id = ./src/app/components/admin/configs/admin-configs.component.scss
// module chunks = main